interface IconProps {
  color?: string
}

export const Email = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.80005 10.6674C3.80005 7.97966 5.97893 5.80078 8.66672 5.80078H23.3334C26.0212 5.80078 28.2 7.97966 28.2 10.6674V21.3341C28.2 24.0219 26.0212 26.2008 23.3334 26.2008H8.66672C5.97893 26.2008 3.80005 24.0219 3.80005 21.3341V10.6674ZM8.66672 7.53411C6.93622 7.53411 5.53338 8.93696 5.53338 10.6674V21.3341C5.53338 23.0646 6.93622 24.4674 8.66672 24.4674H23.3334C25.0639 24.4674 26.4667 23.0646 26.4667 21.3341V10.6674C26.4667 8.93696 25.0639 7.53411 23.3334 7.53411H8.66672ZM7.33426 11.446C7.64068 11.0782 8.18717 11.0286 8.55488 11.335L14.8477 16.579C15.5152 17.1353 16.4849 17.1353 17.1524 16.579L23.4452 11.335C23.8129 11.0286 24.3594 11.0782 24.6658 11.446C24.9723 11.8137 24.9226 12.3602 24.5549 12.6666L20.2159 16.2824L24.5641 20.0094C24.9275 20.3209 24.9696 20.8681 24.6581 21.2315C24.3466 21.5949 23.7995 21.637 23.436 21.3255L18.8654 17.4078L18.262 17.9106C16.9517 19.0025 15.0484 19.0025 13.7381 17.9106L13.1347 17.4078L8.56408 21.3255C8.20066 21.637 7.65354 21.5949 7.34204 21.2315C7.03054 20.8681 7.07262 20.3209 7.43604 20.0094L11.7842 16.2824L7.44522 12.6666C7.07752 12.3602 7.02783 11.8137 7.33426 11.446Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
